/* ============
 * The initial state of the report module.
 * ============
 */
export default {
  isReportsLoading: false,
  isResolvedsymptomsLoading:false,
  reports: [],
  resolvedsymptoms: [],
  resolvedtotalCount: 0,
  totalCount: 0,
  issymptomsLoading:false,
  symptoms: [],
  symptomstotalCount: 0,
  allpatients:[],
  allpatientstotalCount:0,
  isallpatientsLoading:false,
  patientbyidreport:[],
  ispatientbyidreportLoading:false,
  isweeklyreportLoading:false,
  weeklyreports:[],
  isyearlyreportLoading:false,
  yearlyreports:[]
};
